import React from 'react'
import { useState } from 'react'
import { connect } from 'react-redux'
import { Item } from '../../common/snippets'
import * as sx from '../../common/stylesInline/report_daily_branch'
import * as id from './common/AcountingId'
import * as lb from './common/AcountingLables'
import { Box, Button } from '@mui/material'
import DropDownOA from '../../common/dropDownOA'
import Datepicker from '../../common/datePicker'
import moment from 'moment'
import { RefreshSvg } from '../../common/svg/refresh'
import { SplitButton } from '../../common/SplitButton'
import { AcountingHeading } from './common/AcountingHeading'
import { appendToUrl, diffInMonths, focusElemnt, isEmpty, navigation3, removeDuplicatesFromArray } from '../../common/helper'
import { getCreditSummaryData, getOwnChildBranches, getReportBranchList } from '../../../store/reports/reports_action'
import { useEffect } from 'react'
import * as URL from '../Reports/oldReportsUrls'
import { getBranchConfigOrEwbillinfo, updateAlertError } from '../../../store/common/common_action'
import TableViewCreditSummary from './TableViewCreditSummary'
import TableViewCreditSummaryNew from './TableViewCreditSummaryNew'
import { GetRequest, PostRequest, PostRequestCachedV3 } from '../../common/api'
import { urls } from '../../common/constants'
const CreditSummaryReport = (props) => {
  const {
    data: { common, reports },
    getOwnChildBranches,
    getBranchConfigOrEwbillinfo,
    getReportBranchList,
    getCreditSummaryData,
    updateAlertError,
  } = props
  const { ownChildBranches1, reportBranchList, creditSummaryReportData } = reports
  const { loginData, citywiseBranchList, roleRights } = common
  const reportName = 'Branch Credit Limit Summary'
  const [stateList, setStateList] = useState([])
  const [sourceCityList, setSourceCityList] = useState([])
  const [sourceBranchList, setSourceBranchList] = useState([])
  const [selState, setSelState] = useState([])
  const [selSourceCity, setSelSourceCity] = useState([])
  const [selSourceBranch, setSelSourceBranch] = useState()
  const [selView, setSelView] = useState({ id: 0, name: 'Old Summary' })
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [isExpanded, setIsExpanded] = useState(false)
  const [resetFlag, setResetFlag] = useState(false)
  const [filterSourceCityList, setFilterSourceCityList] = useState([])
  const [disableBtn, setDisableBtn] = useState(false)
  const viewList = [
    { id: 0, name: 'Old Summary' },
    { id: 1, name: 'New Summary' },
  ]
  useEffect(() => {
    focusElemnt(id.creditSummaryFromDate)
  }, [])
  useEffect(() => {
    if (!isEmpty(loginData)) {
      const branchData = {
        intUserID: loginData?.intUserID,
        intCompanyID: loginData?.intCompanyID,
        intIsActive: 1,
      }
      getOwnChildBranches(branchData, true, 24 * 60 * 60 * 1000)
      setSelSourceBranch({ BranchName: loginData?.strBranchName, BranchID: loginData?.intBranchID })
    }
  }, [loginData])
  useEffect(() => {
    if (!isEmpty(roleRights)) {
      if (roleRights?.Table1?.[0]?.AllowViewAllBranchReport || loginData?.IsBranchAdmin || loginData?.IsMTPLAdmin || loginData?.IsAdmin) {
        const obj = {
          intUserID: 0,
          intCompanyID: loginData?.intCompanyID,
          intBranchID: 0,
          strBranchName: '',
          strBranchCode: '',
          intStateID: 0,
          intCityID: 0,
          intIsActive: 1,
        }
        PostRequestCachedV3(urls.getBranchConfigOrEwbillinfo, obj, true, 24 * 60 * 60 * 1000).then((res) => {
          if (res.status === 'Success') {
            const filteredList = res?.Data?.Table?.filter(item => item.IsCargoCreditLimit === 1);
            setSourceBranchList(filteredList);
           // setSourceBranchList(res?.Data?.Table)
          }
        })
             } else if (!roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport && roleRights?.Table1?.[0]?.AllowBranchInchargeRights) {
        const obj = {
          CompanyID: loginData?.intCompanyID,
          CityID: loginData?.intCityID,
          UserID: loginData?.intUserID,
          BranchID: loginData?.intBranchID,
          Mode: 1,
        }
        GetRequest(urls.getReportBranchList, obj).then((res) => {
          if (res.status == 'Success') {
            setSourceBranchList(res?.Data?.Table)
          }
        })
        // getReportBranchList(obj)
        // setSourceBranchList(reportBranchList)
      } else {
        const obj = {
          intUserID: 0,
          intCompanyID: loginData?.intCompanyID,
          intBranchID: 0,
          strBranchName: '',
          strBranchCode: '',
          intStateID: 0,
          intCityID: loginData?.intCityID,
          intIsActive: 1,
        }
        PostRequest(urls.getBranchConfigOrEwbillinfo, obj).then((res) => {
          if (res.status === 'Success') {
            const filteredList = res?.Data?.Table?.filter(item => item.IsCargoCreditLimit === 1);
            setSourceBranchList(filteredList);
            //setSourceBranchList(res?.Data?.Table)
          }
        })
      }
    }
  }, [roleRights, loginData])
  useEffect(() => {
    if (!isEmpty(roleRights) && !isEmpty(loginData)) {
      setDisableBtn(
        !(
          roleRights?.Table1?.[0]?.AllowViewAllBranchReport ||
          roleRights?.Table1?.[0]?.AllowBranchInchargeRights ||
          loginData?.IsBranchAdmin ||
          loginData?.IsMTPLAdmin ||
          loginData?.IsAdmin
        )
      )
      //setDisableExcel(!(roleRights?.Table1?.[0]?.AllowExportExcel))
    }
  }, [roleRights, loginData])
  useEffect(() => {
    if (!isEmpty(ownChildBranches1)) {
      if (ownChildBranches1?.length > 0) {
        let data = []
        let data1 = []
        ownChildBranches1?.map((val, i) => {
          data.push({ StateID: val?.StateID, StateName: val?.StateName })
          data1.push({ CityName: val?.CityName, CityID: val?.CityID, StateID: val?.StateID })
        })
        // setStateList([{ StateName: 'All', StateID: 0 }, ...data])
        // setSourceCityList([{ CityName: 'All', CityID: 0 }, ...data1])
        // //filter cityList for city
        // setFilterSourceCityList([{ CityName: 'All', CityID: 0 }, ...data1])
        setStateList(data)
        setSourceCityList(data1)
        //filter cityList for city
        setFilterSourceCityList(data1)
        //deafultValue
        setSelState({
          StateName: ownChildBranches1.filter((obj) => obj.CityID === loginData?.intBranchCityID)[0]?.StateName,
          StateID: ownChildBranches1.filter((obj) => obj.CityID === loginData?.intBranchCityID)[0]?.StateID,
        })
        setSelSourceCity({ CityName: loginData?.strCityName, CityID: loginData?.intBranchCityID })
      } else {
        setStateList([])
        setSourceCityList([])
        setSelState('')
        setSelSourceCity('')
      }
    }
  }, [ownChildBranches1])
  const handleClick1 = () => {
    if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      updateAlertError({ show: true, msg: 'Selected Date Range is More Then One Month', nextId: '' })
    } else {
      setIsExpanded(true)
      const obj = {
        intCompanyID: loginData?.intCompanyID,
        intBranchID: selSourceBranch?.BranchID,
        dtFromDate: fromDate.format('YYYY-MM-DD'),
        dtToDate: toDate.format('YYYY-MM-DD'),
        intUserID: loginData?.intUserID,
      }
      getCreditSummaryData(obj)
    }
  }
  const handleClick2 = () => {
    let url = URL.creditSummaryReport
    const urlData = URL.creditSummaryReportParams
    urlData.chk = loginData.BusCrsCheckSum
    urlData.intCompanyID = loginData?.intCompanyID
    urlData.intBranchID = loginData?.intBranchID
    urlData.intUserID = loginData?.intUserID
    urlData.dtfromDate = fromDate.format('DD-MMM-YYYY')
    urlData.dtToDate = toDate.format('DD-MMM-YYYY')
    urlData.selectedBranchName = selSourceBranch?.BranchName
    urlData.intAllowExportToExcel = 1
    url = appendToUrl(url, urlData)
    window.open(url, '_blank')
  }
  const handleStateChange = (stateId) => {
    if (stateId !== 0) {
      // setResetCity(true)
      const filteredCities = sourceCityList.filter((val) => val.StateID === stateId)
      setFilterSourceCityList(filteredCities)
      setSelSourceCity(filteredCities?.[0] || ' ')
      const filteredBranch = removeDuplicatesFromArray(sourceBranchList, 'BranchID').filter((val) => val.CityID === filteredCities?.[0]?.CityID || filteredCities?.[0]?.CityID === 0 || val.BranchID === 0)
      // setSelSourceCity({ CityName: 'All', CityID: 0 })
      setSelSourceBranch(filteredBranch?.[0] || ' ')
      // setSourceBranchList([])
    } else {
      setFilterSourceCityList(sourceCityList)
    }
  }
  function subtractDaysFromDate(date, days) {
    const formattedDate = moment(date, 'YYYY-MM-DD').subtract(days, 'days').format('YYYY-MM-DD')
    return formattedDate
  }
  function addDaysToDate(date, days) {
    const newDate = new Date(date)
    newDate.setDate(newDate.getDate() + days)
    return newDate.toISOString().split('T')[0] // Returns the date in "YYYY-MM-DD" format
  }
  const selectedSourceCity = (obj) => {
    setIsExpanded(false)
    setSelSourceCity(obj)
    // setSourceBranch(removeDuplicatesFromArray(sourceBranchData,"SourceBranchID").filter((val) => val.SourceCityID === obj?.SourceCityID || obj?.SourceCityID === 0 || val.SourceBranchID === 0)?.[0]) 
    setSelSourceBranch(removeDuplicatesFromArray(sourceBranchList, 'BranchID').filter((item) => item.CityID === obj?.CityID || obj?.CityID === 0 || item.BranchID === 0)?.[0])
  }
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        <AcountingHeading reportName={reportName} />
        <Box sx={sx.reportFlex}>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.selectCompany}
              label={lb.select_company}
              defaultvalue={loginData.strCompanyName}
              disabled={true}
              minWidth="250px"
              width="300px"
            />
          </Item>
          <Item sx={sx.itemsx} className="disabled-wrapper">
            <Button variant="contained" disabled={true} style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary">
              GO
            </Button>
          </Item>
          <Item sx={sx.itemsx} className="input--container bookingDatePicker">
            <Datepicker
              label={`From Booking Date`}
              // name={'from_date'}
              id={id.creditSummaryFromDate}
              // value={fromDate}
              dateChange={(date) => {
                setFromDate(date)
                focusElemnt(id.toDate)
              }}
              //  width="210px"
              startDate={'2022-01-01'}
              //startDate={subtractDaysFromDate(moment().format('YYYY-MM-DD'), 365)} //will return previous 1 year date
              endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 0)} //will return future 1 year date
            />
          </Item>
          <Item sx={sx.itemsx} className="input--container bookingDatePicker">
            <Datepicker
              label={'To Booking Date'}
              // name={'to_date'}
              id={id.toDate}
              // value={toDate}
              dateChange={(date) => {
                setToDate(date)
                focusElemnt(disableBtn ? id.creditSummarySplitButton : id.stateId)
              }}
              // width="210px"
              startDate={'2022-01-01'}
              //startDate={subtractDaysFromDate(moment().format('YYYY-MM-DD'), 365)} //will return previous 1 year date
              endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 0)} //will return future 1 year date
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.stateId}
              label={'Select State'}
              data={removeDuplicatesFromArray(stateList, 'StateID') || []}
              defaultvalue={selState?.StateName}
              idKey={`StateID`}
              dataKey={`StateName`}
              onSelect={(val) => {
                setSelState(val)
                setIsExpanded(false)
                handleStateChange(val.StateID)
              }}
              isObjArr={true}
              //searchPlaceholder={`Search By Report Type`}
              width="310px"
              nextId={id.srcCity}
              prevId={id.toDate}
              resetFlag={resetFlag}
              disabled={disableBtn}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.srcCity}
              label={'Select City'}
              data={removeDuplicatesFromArray(filterSourceCityList, 'CityID') || []}
              defaultvalue={selSourceCity?.CityName}
              idKey={`CityID`}
              dataKey={`CityName`}
              // onSelect={(val) => {
              //   setIsExpanded(false)
              //   setSelSourceCity(val)
              // const defaultBranch=removeDuplicatesFromArray(filterSourceCityList, 'CityID').filter(
              //   (item) => item.CityID === val?.CityID || val?.CityID === 0 || item.BranchID === 0
              // ) 
              //   setSelSourceBranch(defaultBranch?.[0])
              // }}
              onSelect={(obj) => selectedSourceCity(obj)}
              isObjArr={true}
              searchPlaceholder={`Search By Report Type`}
              width="310px"
              nextId={id.srcBranch}
              prevId={id.stateId}
              resetFlag={resetFlag}
              disabled={disableBtn}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.srcBranch}
              label={'Select Branch'}
              // data={removeDuplicatesFromArray(sourceBranchList, 'BranchID') || []} //hardcoded dataList
              data={removeDuplicatesFromArray(sourceBranchList, 'BranchID').filter(
                (val) => val.CityID === selSourceCity?.CityID || selSourceCity?.CityID === 0 || val.BranchID === 0
              ) || []}
              defaultvalue={selSourceBranch?.BranchName || selSourceBranch}
              // data={removeDuplicatesFromArray(sourceBranchList?.filter((val)=>val.CityID==selSourceCity?.CityID), 'BranchID') || []} //hardcoded dataList
              // defaultvalue={selSourceBranch?.BranchName}
              idKey={`BranchID`}
              dataKey={`BranchName`}
              onSelect={(val) => {
                setIsExpanded(false)
                setSelSourceBranch(val)
              }}
              isObjArr={true}
              searchPlaceholder={`Search By Report Type`}
              width="310px"
              nextId={id.summaryView}
              prevId={id.srcCity}
              resetFlag={resetFlag}
              disabled={disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 0}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.summaryView}
              label={'Select View'}
              data={viewList || []}
              defaultvalue={selView?.name}
              idKey={`id`}
              dataKey={`name`}
              onSelect={(val) => {
                setIsExpanded(false)
                setSelView(val)
              }}
              isObjArr={true}
              searchPlaceholder={`Search By Report Type`}
              width="310px"
              nextId={id.creditSummarySplitButton}
              prevId={id.srcBranch}
              resetFlag={resetFlag}
              disabled={disableBtn}
            />
          </Item>
          <Item
            sx={sx.itemsx}
            onKeyDown={(e) => navigation3(e, isExpanded ? 'creditSummaryExcelBtn' : id.creditSummaryFromDate, () => handleClick1())}
          >
            <SplitButton
              options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
              // hideToggle={false}
              id1={id.creditSummarySplitButton}
              prevID={disableBtn ? id.toDate : id.summaryView}
              onClick1={handleClick1}
              onClick2={handleClick2}
            />
          </Item>
          <Item
            sx={{ ...sx.itemsx }}
            onClick={() => {
              setResetFlag(!resetFlag)
            }}
          >
            <RefreshSvg />
          </Item>
        </Box>
      </Item>
      <Item>
        {isExpanded ? (
          selView.id ? (
            <TableViewCreditSummaryNew
              tableData={creditSummaryReportData}
              loginData={loginData}
              fromDate={fromDate}
              toDate={toDate}
              company={loginData?.strCompanyName}
              StateName={selState?.StateName}
              city={selSourceCity?.CityName}
              branch={selSourceBranch?.BranchName}
            />
          ) : (
            <TableViewCreditSummary
              tableData={creditSummaryReportData}
              loginData={loginData}
              fromDate={fromDate}
              toDate={toDate}
              company={loginData?.strCompanyName}
              StateName={selState?.StateName}
              city={selSourceCity?.CityName}
              branch={selSourceBranch?.BranchName}
            />
          )
        ) : (
          ''
        )}
      </Item>
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
  getOwnChildBranches,
  getBranchConfigOrEwbillinfo,
  getReportBranchList,
  getCreditSummaryData,
  updateAlertError,
}
export default connect(mapStateToProps, mapDispatchToProps)(CreditSummaryReport)
